'use strict';

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}

// polyfills the toJSON method for map and set so that redux dev tools can display those types of objects nicely
require('map.prototype.tojson');
require('set.prototype.tojson');

// adds a lot of polyfills - if we need to reduce bundle size, we can probably remove this in favor of including the specific polyfills that we need
// So far, we need:
// array.includes
// array.find
require('babel-polyfill');



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 253
// module chunks = 0